import { render, staticRenderFns } from "./MockBanner.vue?vue&type=template&id=f1bf96ea&scoped=true"
import script from "./MockBanner.vue?vue&type=script&lang=js"
export * from "./MockBanner.vue?vue&type=script&lang=js"
import style0 from "./MockBanner.vue?vue&type=style&index=0&id=f1bf96ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../mbp_crm-adminclient-align/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1bf96ea",
  null
  
)

export default component.exports